export enum ETranslationType {
    TITLE = 'title',
    HELPER = 'helper'
}